import { GET, POST, POST_FILES, PUT } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/voucher/${endpoint}`;
};

export const searchVouchers = (request, token) => {
  const endpoint = getEndpointWithPrefix('search');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export function extendVoucherValidity(voucherCode, notifyViaSms, request, token) {
  const endpoint = getEndpointWithPrefix(`extend?voucherCode=${voucherCode}&isNotifyViaSms=${notifyViaSms}`);
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
}

export const activateVoucher = (request, token) => {
  const endpoint = getEndpointWithPrefix('activate');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const getQrPdf = (request, token) => {
  const endpoint = getEndpointWithPrefix('generateQR/qrList');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const getQrZpl = (uploadedFile, token) => {
  const endpoint = getEndpointWithPrefix('generateQR/list/zpl');
  return POST_FILES(endpoint, uploadedFile, token);
};

export const getCarrierPdf = (request, token) => {
  const endpoint = getEndpointWithPrefix('carrier-board/printable/pdf');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const getCarrierBook = (request, token) => {
  const endpoint = getEndpointWithPrefix(
    'carrier-board/printable/pdf-template'
  );
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const getAddOns = (token) => {
  const endpoint = getEndpointWithPrefix('addOns');
  return GET(endpoint, token);
}

export const searchAddOnDropdownList = (token, searchKey, searchId, sortBy, sortDirection) => {
  const endpoint = getEndpointWithPrefix(`get-dropdown-addons?searchKey=${encodeURIComponent(searchKey)}&searchId=${searchId}&sortBy=${sortBy}&sortDirection=${sortDirection}`);
  return GET(endpoint, token);
}

export const listBulkComplete = (request, token) => {
  const endpoint = getEndpointWithPrefix('bulk-complete-list');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const uploadBulkOrder = (uploadedFile, token) => {
  const endpoint = getEndpointWithPrefix('bulk-order');
  return POST_FILES(endpoint, uploadedFile, token);
};

export const getVouchersByStatus = (
  token,
  statusKey,
  currentPage,
  pageSize
) => {
  const endpoint = getEndpointWithPrefix(
    `getVouchers?statusKey=${statusKey}&page=${currentPage}&pageSize=${pageSize}&sortBy=created_date&order=desc`
  );
  return GET(endpoint, token);
};

export const getPendingPurchases = (token, pageSize, currentPage) => {
  const endpoint = getEndpointWithPrefix(
    `getPendingVouchers/?page=${currentPage}&pageSize=${pageSize}&sortBy=id&order=desc`
  );
  return GET(endpoint, token);
};

export const searchPendingPurchases = (
  token,
  searchKey,
  currentPage,
  pageSize,
  dates
) => {
  let query = `search-pending-vouchers?searchKey=${searchKey}&page=${currentPage}&pageSize=${pageSize}&sortBy=id&order=desc`;

  if (dates.startDate && dates.endDate) {
    query = query.concat(
      `&startDate=${dates.startDate}&endDate=${dates.endDate}`
    );
  }

  const endpoint = getEndpointWithPrefix(query);
  return GET(endpoint, token);
};

export const getTransactions = (token, voucherId) => {
  let query = `transaction/${voucherId}`;
  const endpoint = getEndpointWithPrefix(query);
  return GET(endpoint, token);
};

export const getTransferredData = (token, voucherId) => {
  let query = `transfers/${voucherId}`;
  const endpoint = getEndpointWithPrefix(query);
  return GET(endpoint, token);
};

export const getVoucherQRbyCSV = (uploadedFile, token) => {
  const endpoint = getEndpointWithPrefix('generateQR');
  return POST_FILES(endpoint, uploadedFile, token);
};

export const getAllPackagingType = (token) => {
  const endpoint = getEndpointWithPrefix(`packaging-types`);
  return GET(endpoint, token);
};

export const updateOwnership = (request, token) => {
  const endpoint = getEndpointWithPrefix(`transfer/ownership`);
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const reNotifyVoucher = (request, token) => {
  const endpoint = getEndpointWithPrefix('re-notify');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const updateVoucherDetails = (voucherId, request, token) => {
  const endpoint = getEndpointWithPrefix(`${voucherId}/update`);
  return PUT(endpoint, request, token).then((response) => {
    return response;
  });
};

export const updateMultipleVoucherStatus = (request, token) => {
  const endpoint = getEndpointWithPrefix(`status/update`);
  return PUT(endpoint, request, token).then((response) => {
    return response;
  });
};

export const getDeliveryEmail = (voucherId, token) => {
  const endpoint = getEndpointWithPrefix(`${voucherId}/delivery-email`);
  return GET(endpoint, token).then((response) => {
    return response;
  });
};

